import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  isInternational(): boolean {
    return environment.Brand === 'international';
  }
}
